import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import logo from ".././Assets/logo.png";
import bg from ".././Assets/bg.png";

const defaultTheme = createTheme();

export default function SignIn() {
  let navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      const userCreds = await signInWithEmailAndPassword(
        auth,
        data.get("email"),
        data.get("password")
      );

      toast.success("You have logged in successfully");
      localStorage.setItem("authToken", userCreds.user.accessToken);
      navigate("/Dashboard");
    } catch (error) {
      toast.error(`Sign up failed: ${error.message}`);
      console.log(error);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container
        sx={{ backgroundImage: `url(${bg})` }}
        component="main"
        maxWidth="xs"
      >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img style={{ margin: "10px" }} height="80px" src={logo} alt="" />
          <Box sx={{ border: "1px solid #dddddd", borderRadius: "10px" }}>
            <Box sx={{ padding: "40px" }}>
              <Typography
                sx={{ mb: "25px", color: "#4d4d4d" }}
                component="h1"
                variant="h5"
              >
                Sign in
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1, width: "320px" }}
              >
                <Typography sx={{ mb: "-10px", color: "#949494" }}>
                  Email
                </Typography>
                <TextField
                  hiddenLabel
                  sx={{ mb: "30px" }}
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  placeholder="Enter email address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                />
                <Typography sx={{ mb: "-10px", color: "#949494" }}>
                  Password
                </Typography>
                <TextField
                  hiddenLabel
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  type="password"
                  id="password"
                  placeholder="Enter Password"
                  autoComplete="current-password"
                />
                <Grid item xs>
                  <Link
                    sx={{ color: "#f38500", textDecoration: "none" }}
                    component={RouterLink}
                    to={"/ResetPassword"}
                    variant="body2"
                  >
                    Forgot password?
                  </Link>
                </Grid>
                {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 3,
                    mb: 2,
                    backgroundColor: "#F2A040",
                    borderColor: "#F2A040",
                    boxShadow: "none",
                    ":hover": {
                      borderColor: "#F2A040",
                      backgroundColor: "#F2A040",
                      color: "#ffffff",
                      boxShadow: "none",
                    },
                  }}
                >
                  Sign In
                </Button>
                <Grid container>
                  <Grid item>
                    <Link
                      sx={{ color: "#000", textDecoration: "none" }}
                      component={RouterLink}
                      to="/SignUp"
                      variant="body2"
                    >
                      "Don't have an account?{" "}
                      <span
                        style={{ color: "#f38500", textDecoration: "none" }}
                      >
                        Sign Up"
                      </span>
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
